import "./LazyImageComp.css";
import { defineComponent as g, ref as l, onMounted as y, watch as d, openBlock as s, createElementBlock as c, createBlock as b, createCommentVNode as _, createElementVNode as C, toDisplayString as I } from "vue";
import { IconComp as k } from "./IconComp.js";
import { _ as w } from "./_plugin-vue_export-helper.dad06003.js";
const h = ["src"], z = {
  key: 2,
  class: "lazyImageComp__unavailable"
}, L = { class: "lazyImageComp__unavailableText" }, x = /* @__PURE__ */ g({
  __name: "LazyImageComp",
  props: {
    src: {},
    unavailableText: {},
    showLoadingAnimation: { type: Boolean }
  },
  setup(p) {
    const r = p, i = l(null), t = l(!1), o = l(!1), n = l(null), u = async (e = !1) => {
      if (!((n.value || o.value) && !e))
        try {
          o.value = !1, t.value = !0;
          const a = await fetch(r.src, {});
          if (a.ok) {
            const m = await a.blob();
            n.value = window.URL.createObjectURL(m);
            return;
          }
          o.value = !0;
        } finally {
          t.value = !1;
        }
    };
    return y(() => {
      if (i.value) {
        const e = async (v) => {
          for (const f of v)
            f.isIntersecting && await u();
        }, a = {
          root: null
        };
        new IntersectionObserver(e, a).observe(i.value);
      } else
        o.value = !0;
    }), d(
      () => r.src,
      async (e, a) => {
        e && e !== a && await u(!0);
      }
    ), (e, a) => (s(), c("div", {
      ref_key: "imageContainer",
      ref: i
    }, [
      !o.value && t.value && e.showLoadingAnimation ? (s(), b(k, {
        key: 0,
        class: "lazyimageComp__loadingAnimation",
        icon: "ellipsis_loading"
      })) : _("", !0),
      !o.value && n.value && !t.value ? (s(), c("img", {
        key: 1,
        class: "lazyImageComp__img",
        src: n.value
      }, null, 8, h)) : t.value ? _("", !0) : (s(), c("div", z, [
        C("p", L, I(r.unavailableText), 1)
      ]))
    ], 512));
  }
});
const N = /* @__PURE__ */ w(x, [["__scopeId", "data-v-36981258"]]);
export {
  N as LazyImageComp
};
//# sourceMappingURL=LazyImageComp.js.map
